export const END_POINTS = {
    MODIFIER_GROUP: '/modifier_groups',
    MODIFIER: '/modifiers'
}
